// material
import { Card, Container, Typography, Link, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

// import { FormProvider, useForm } from 'react-hook-form';
// sections
import CreateAdminForm from '../sections/form/CreateAdminForm';
// hooks
import useResponsive from '../hooks/useResponsive';

// components
import Page from '../components/Page';
import BasicBreadcrumb from '../components/BasicBreadcrumb';

const RootStyle = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center'
}));
const SectionStyle = styled('div')(({ theme }) => ({
  width: '100%',
  //maxWidth: '60%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(2),
  padding: theme.spacing(2)
}));
const ContentStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  //maxWidth: '60%',
  margin: theme.spacing(2),
  display: 'flex',
  justifyContent: 'flex-end',
  flexDirection: 'column',
  padding: theme.spacing(2)
}));

import { useTranslation } from 'react-i18next';

export default function CreateAdmin() {
  const { t } = useTranslation();
  const mdUp = useResponsive('up', 'md');

  const identityName = t('nav.admin');

  const bread = [
    <Link href="/admin" underline="hover" key="1" color="inherit">
      {t('admin.title')}
    </Link>,
    <Typography key="2" color="text.primary">
      {t('people.create_title', { identity: identityName })}
    </Typography>
  ];

  return (
    <Page title={t('people.create_title', { identity: identityName })}>
      <Container maxWidth={false}>
        <Stack direction="column">
          <Typography variant="h4" sx={{ mb: 5 }}>
            {t('people.create_title', { identity: identityName })}
          </Typography>
          <BasicBreadcrumb bread={bread} />
        </Stack>
        <RootStyle>
          {mdUp && (
            <SectionStyle>
              <img src="/static/illustrations/illustration_register.png" alt="create admin" />
            </SectionStyle>
          )}

          <ContentStyle>
            <Typography variant="h6" sx={{ mt: 1, mb: 4 }}>
              {t('people.fill_info')}
            </Typography>
            <CreateAdminForm />
          </ContentStyle>
        </RootStyle>
      </Container>
    </Page>
  );
}
